import styled from "styled-components"

export default styled.img`
  margin-top: -106px;
  margin-left: auto;
  margin-right: auto;
  display: block;
  transform: translate3d(22.5px, 0, 0);
`
